import * as errors from '@attain-apps/errors'

export class UnsupportedNodeError extends errors.NotImplementedError {
  constructor() {
    super({
      description: `Expression nodes that are neither values nor functions`,
    })
  }
}
